import { useTranslation } from "react-i18next";
import style from '../../assets/style/advertusments.module.css';
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Glyphs from '../../assets/Images/logoGlyphs.png';
import { useSelector } from 'react-redux';
import { homeState } from '../../redux/Home/home';

function Advertusments() {
    const stateHome = useSelector(homeState);
    const homeStateTry = stateHome?.homeData?.try_app;
    const [t] = useTranslation();
    const location = useLocation();
    const [adverShow, setAdverShow] = useState(false);
    
    useEffect(() => {
        const isHomePage = location.pathname === "/" || location.pathname === "/home";
        setAdverShow(isHomePage);
    }, [location]);
    
    return (
        <>
            {adverShow && (
                <div className={style.adverContainer}>
                    <div className={style.contentWrapper}>
                        <div className={style.brandSection}>
                            <LazyLoadImage 
                                src={Glyphs} 
                                alt="Glyphs Marketing Logo" 
                                className={style.logoGlyphs} 
                            />
                            <div className={style.brandText}>
                                {t("For More Services Visit Our website")}: {" "}
                                <a 
                                    href="https://glyphsmarketing.com" 
                                    target="_blank" 
                                    rel="noreferrer"
                                    className={style.brandLink}
                                >
                                    {t("Visit")}
                                </a>
                            </div>
                        </div>
                        
                        <div className={style.appSection}>
                            <div className={style.appText}>
                                {t("Download Our App in")} {" "}
                                <a 
                                    href={homeStateTry?.ios?.link} 
                                    target="_blank" 
                                    rel="noreferrer"
                                    className={style.appLink}
                                > 
                                    iOS
                                </a>
                                <span className={style.separator}>{t("or")}</span>
                                <a 
                                    rel="noreferrer" 
                                    target="_blank" 
                                    href={homeStateTry?.android?.link}
                                    className={style.appLink}
                                >
                                    Android
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Advertusments;
